import { createFileRoute } from '@tanstack/react-router';
import StakingDashboard from '../../../components/staking/StakingDashboard';
import LoadingPage from '../../../components/shared/page-components/LoadingPage';
import { StakingProvider } from '../../../components/staking/providers/StakingProvider';

function StakingDashboardPage() {
  return (
    <StakingProvider>
      <StakingDashboard />
    </StakingProvider>
  );
}

export const Route = createFileRoute('/_authenticated/staking/')({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: StakingDashboardPage,
  staticData: {
    configPageId: 'staking',
    meta: {
      title: 'Staking Dashboard | Ledgible',
    },
  },
});
